import { LoaderFunctionArgs } from 'react-router-dom'
import { store } from '@/app/store'
import { fetchSurvayQuestions } from '@/features/survey/survey-questions-slice'
import { resetAllSurveyState } from '@/features/survey'
import { redirect } from 'react-router-dom'
import { checkout } from '@/features/checkout/checkout-data-slice'

/**
 * チェックアウトレビュー画面用のアンケートデータをロード
 * チェックアウトフロー内でアンケート質問を事前取得
 */
export const loadCheckoutReviewSurvey = async ({ request }: LoaderFunctionArgs) => {
  // checkout 対象の予約を取得
  const checkoutReservations = store.getState().checkout.checkoutReservation.checkoutReservations
  const hotelId = new URL(request.url).searchParams.get('hotelId')

  if (!checkoutReservations.length || !hotelId) {
    return null
  }

  // アンケート関連のstateをリセット（前の回答と混ざらないようにする）
  store.dispatch(resetAllSurveyState())

  // アンケートを取得できない場合は、エラーを握りつぶしてチェックアウトを実行する
  try {
    await store
      .dispatch(
        fetchSurvayQuestions({
          reservationIds: checkoutReservations.map(reservation => reservation.reservationId),
          hotelId,
        }),
      )
      .unwrap()
  } catch (error: any) {
    for (const reservation of checkoutReservations) {
      await store.dispatch(
        checkout({
          hotelId: hotelId,
          checkinId: '',
          reservationId: reservation.reservationId,
          withReview: true,
        }),
      )
    }
    return redirect('/checkout/thanks')
  }
  return null
}

/**
 * アンケート詳細画面用のアンケートデータをロード
 * 単体のアンケートページで質問を事前取得
 */
export const loadSurveyDetail = async ({ request }: LoaderFunctionArgs) => {
  const hotelId = new URL(request.url).searchParams.get('hotelId')
  const reservationIds = new URL(request.url).searchParams.getAll('reservationIds')

  //早期リターン
  if (!hotelId || !reservationIds.length) {
    console.error('hotelId or reservationIds is not found')
    return redirect('/error-404')
  }

  // アンケート関連のstateをリセット（前の回答と混ざらないようにする）
  store.dispatch(resetAllSurveyState())

  try {
    await store
      .dispatch(
        fetchSurvayQuestions({
          reservationIds,
          hotelId,
        }),
      )
      .unwrap()
  } catch (error: any) {
    if (error.response?.status === 403) {
      return redirect('/survey/duplicate-answer')
    } else {
      return redirect('/error-404')
    }
  }

  return null
}
